"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.areObjRefsEqual = exports.deserializeObjRef = exports.serializeObjRef = exports.objRefToString = exports.isLocalIdRef = exports.isObjRef = exports.isIdentifierRef = exports.isUriRef = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
//
// Type guards
//
/**
 * Type guard checking whether object is an URI Reference.
 *
 * @public
 */
function isUriRef(obj) {
    return !isEmpty_1.default(obj) && obj.uri !== undefined;
}
exports.isUriRef = isUriRef;
/**
 * Type guard checking whether object is an Identifier Reference.
 *
 * @public
 */
function isIdentifierRef(obj) {
    return !isEmpty_1.default(obj) && obj.identifier !== undefined;
}
exports.isIdentifierRef = isIdentifierRef;
/**
 * Type guard checking whether object is an Identifier Reference or an URI reference.
 *
 * @public
 */
function isObjRef(obj) {
    return isUriRef(obj) || isIdentifierRef(obj);
}
exports.isObjRef = isObjRef;
/**
 * Type guard checking whether object is a localId Reference.
 *
 * @public
 */
function isLocalIdRef(obj) {
    return !isEmpty_1.default(obj) && obj.localIdentifier !== undefined;
}
exports.isLocalIdRef = isLocalIdRef;
/**
 * Retrieves string representation of object reference. This is purely for for representation of
 * references in text, debug and tests.
 *
 * @internal
 */
function objRefToString(objRef) {
    ts_invariant_1.default(objRef, "object reference must be specified");
    if (isIdentifierRef(objRef)) {
        return "" + objRef.identifier;
    }
    else if (isUriRef(objRef)) {
        return objRef.uri;
    }
    return objRef.localIdentifier;
}
exports.objRefToString = objRefToString;
/**
 * Serializes an instance of ObjRef to a string representation. This is suitable when ObjRef needs to be used
 * as a key in dictionaries/objects.
 *
 * Note: there is no loss of information and the serialized value is guaranteed to be stable, meaning same ObjRef
 * will always serialize the same.
 *
 * @param objRef - ref to serialize
 * @remarks see {@link deserializeObjRef}
 * @public
 */
function serializeObjRef(objRef) {
    return json_stable_stringify_1.default(objRef, { space: 0 });
}
exports.serializeObjRef = serializeObjRef;
/**
 * Deserializes an ObjRef from its pure string representation. The function will throw an error if the input
 * is not a valid, serialized ObjRef.
 *
 * @param val - string representation of ObjRef
 * @remarks see {@link serializeObjRef}
 * @public
 */
function deserializeObjRef(val) {
    var obj = JSON.parse(val);
    ts_invariant_1.default(isObjRef(obj) || isLocalIdRef(obj), "Attempting to deserialize ObjRef but the input is invalid: '" + val + "'");
    return obj;
}
exports.deserializeObjRef = deserializeObjRef;
/**
 * Returns a value indicating whether the two ObjRef instances are semantically equal (i.e. are of the same type and have the same value).
 * Null and undefined are considered equal to each other.
 *
 * @remarks If the objects are ObjRefs of multiple types at once (for example they have identifiers and URIs),
 * the match is tested in the following sequence:
 * 1. identifier
 * 2. URI
 * 3. localIdentifier
 *
 * @public
 */
function areObjRefsEqual(a, b) {
    if (a == null) {
        return b == null;
    }
    if (isIdentifierRef(a) && isIdentifierRef(b) && a.type && b.type) {
        return a.identifier === b.identifier && a.type === b.type;
    }
    if (isIdentifierRef(a) && isIdentifierRef(b)) {
        return a.identifier === b.identifier;
    }
    if (isUriRef(a) && isUriRef(b)) {
        return a.uri === b.uri;
    }
    return isLocalIdRef(a) && isLocalIdRef(b) && a.localIdentifier === b.localIdentifier;
}
exports.areObjRefsEqual = areObjRefsEqual;
//# sourceMappingURL=index.js.map